#import "./HaftarahMelodyDetails.graphql"
query HaftarahMelodiesQuery {
  haftarahMelodies {
    ...haftarahMelodyDetails
  }
}
